import React from 'react';
import { Redirect } from 'react-router-dom';
import FuseUtils from '@fuse/utils';
import appsConfigs from 'app/main/apps/appsConfigs';
import LoginConfig from 'app/main/login/LoginConfig';
import ForgotPasswordConfig from 'app/main/forgot/ForgotPasswordConfig';
import ForgotUserConfig from 'app/main/forgotuser/ForgotUserConfig';
import RecruiterConfig from 'app/main/recruiter/recruiterConfigs';
// import pagesConfigs from 'app/main/pages/pagesConfigs';
import TeamLeadConfigs from 'app/main/teamlead/TeamLeadConfig';
import MatchConfigs from 'app/main/match/matchConfigs';
/* Added the following code for POW-872.Harsha using AI Agent. July 9, 2026. Code Start */
import CandidateSignupConfig from 'app/main/candidate/CandidateSignupConfig';
import CandidatePortalConfig from 'app/main/candidate/CandidatePortalConfig';
/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */
import PartnerPortalConfig from 'app/main/partner/PartnerPortalConfig';
/* Code end. Harsha using AI Agent. October 7, 2026 */
/* Code end. Harsha using AI Agent. July 9, 2026 */
// ...pagesConfigs,
const routeConfigs = [
	ForgotPasswordConfig,
	...appsConfigs,
	...RecruiterConfig,
	...TeamLeadConfigs,
	...MatchConfigs,
	ForgotUserConfig,
	/* Added the following code for POW-872.Harsha using AI Agent. July 9, 2026. Code Start */
	CandidateSignupConfig,
	CandidatePortalConfig,
	/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */
	PartnerPortalConfig,
	/* Code end. Harsha using AI Agent. October 7, 2026 */
	/* Code end. Harsha using AI Agent. July 9, 2026 */
	LoginConfig,
];

const routes = [
	...FuseUtils.generateRoutesFromConfigs(routeConfigs),
	{
		path: '/',
		component: () => <Redirect to="/" />
	},
	// {
	// 	component: () => <Redirect to="/pages/errors/error-404" />
	// }

];

export default routes;
